// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.0014 6C13.0014 3.79086 14.7922 2 17.0014 2C19.2105 2 21.0014 3.79086 21.0014 6C21.0014 8.20914 19.2105 10 17.0014 10C14.7922 10 13.0014 8.20914 13.0014 6ZM8.99708 8.14409L13.4895 15.1322L15.9263 11.2333L24.0014 22H0.179688L8.99708 8.14409Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-image-1-filled')
export default class Image1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-1-filled',
    }
  }
}
